import { toSlug } from '../slugs/slug.utils';
import type { Producto } from '../../types/product.types';

/**
 * Obtiene la categoría principal de un producto basado en su slug
 */
export const getCategoryFromProduct = (product: Producto) => {
  return {
    categoria: product.categoria,
    sub_categoria: product.subcategoria,
    slug_categoria: toSlug(product.categoria),
    slug_sub_categoria: toSlug(product.subcategoria),
  };
};

/**
 * Obtiene el slug de categoría más específico para un producto
 * Prioriza la subcategoría si existe, sino usa la categoría principal
 * Esta función recibe el PRODUCTO, no el slug del producto
 */
export const getProductCategorySlug = (product: Producto): string | null => {
  if (!product) return null;

  // Si tiene subcategoría, usar esa (más específica)
  if (product.producto) {
    return toSlug(product.producto);
  }

  // Sino usar la categoría principal
  return toSlug(product.subcategoria);
};
